import React, { useEffect, useState } from 'react';
import ButtonWithIcon from 'chameleon/packages/blue-book-player/library/button-with-icon';

const ResizeButton = ({
  onToggleSize,
  defaultWidth,
  expandedWidth,
  accessibilityResizeButton,
}) => {
  const defaultExpanded = defaultWidth ? defaultWidth === expandedWidth : true;
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  const onClick = () => {
    setIsExpanded((currentIsExpanded) => {
      const newIsResized = !currentIsExpanded;
      onToggleSize(newIsResized);
      return newIsResized;
    });
  };

  useEffect(() => {
    setIsExpanded(defaultExpanded);
  }, [defaultExpanded]);

  return (
    <ButtonWithIcon
      isIcon
      isBlueBookIcon
      isInverted
      roundSize="small"
      iconWidth="16"
      iconHeight="16"
      className="resize-button"
      accessibility={accessibilityResizeButton(isExpanded)}
      icon={isExpanded ? 'reduceWindowSize' : 'increaseWindowSize'}
      data-cy="resize-size-button"
      onClick={onClick}
    />
  );
};

export default ResizeButton;
